import ProductPage from '../pages/crud/ProductPage'
import OrderPage from '../pages/crud/OrderPage'
import IngredientPage from '../pages/crud/IngredientPage'
import ProductCategoryPage from '../pages/crud/ProductCategoryPage'
import BranchPage from '../pages/crud/BranchPage'
import StockPage from '../pages/crud/StockPage'
import StockTransactionPage from '../pages/crud/StockTransactionPage'
import OrderStatePage from '../pages/crud/OrderStatePage'
import {DailyBoxCrudPage} from "../pages/crud/DailyBoxCrudPage";
import {CashRegisterCrudPage} from "../pages/crud/CashRegisterCrudPage";
import {PromoCrudPage} from "../pages/crud/PromoCrudPage";

import CouponCrudPage from '../pages/crud/CouponCrudPage'

import SurveysPage from '../pages/crud/SurveysPage/SurveysPage.vue'
import SurveyResponsesPage from '../pages/crud/SurveyResponsesPage/SurveyResponsesPage.vue'
//import StockDailyPage from '../pages/crud/StockDailyPage'

const routes = [
    {
        name: 'SurveyResponsesPage',
        path: '/crud/surveyresponses',
        component: SurveyResponsesPage,
        metha: {
            requiresAuth: true,
            permission: "SURVEY_RESPONSES_MANAGEMENT"
        }   
    },
    {
        name: 'SurveysPage',
        path: '/crud/surveys',
        component: SurveysPage,
        meta: {
            requiresAuth: true,
            permission: "SURVEYS_MANAGEMENT"
        }
    },
    {
        name: 'ProductPage',
        path: '/crud/product',
        component: ProductPage,
        meta: {
            requiresAuth: true,
            permission: "PRODUCT_SHOW"
        }
    },

    {
        name: 'OrderCrudPage',
        path: '/crud/order',
        component: OrderPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_VIEW_CRUD"
        }
    },

    {
        name: 'IngredientPage',
        path: '/crud/ingredient',
        component: IngredientPage,
        meta: {
            requiresAuth: true,
            permission: "INGREDIENT_SHOW"
        }
    },

    {
        name: 'ProductCategoryPage',
        path: '/crud/productcategory',
        component: ProductCategoryPage,
        meta: {
            requiresAuth: true,
            permission: "PRODUCTCATEGORY_SHOW"
        }
    },

    {
        name: 'BranchPage',
        path: '/crud/branch',
        component: BranchPage,
        meta: {
            requiresAuth: true,
            permission: "BRANCH_SHOW"
        }
    },

    {
        name: 'StockPage',
        path: '/crud/stock',
        component: StockPage,
        meta: {
            requiresAuth: true,
            permission: "STOCK_SHOW"
        }
    },

    {
        name: 'StockTransactionPage',
        path: '/crud/stocktransaction',
        component: StockTransactionPage,
        meta: {
            requiresAuth: true,
            permission: "STOCKTRANSACTION_SHOW"
        }
    },


    {
        name: 'OrderStatePage',
        path: '/crud/orderstate',
        component: OrderStatePage,
        meta: {
            requiresAuth: true,
            permission: "ORDERSTATE_SHOW"
        }
    },

    {
        name: 'DailyBoxCrudPage',
        path: '/crud/dailybox',
        component: DailyBoxCrudPage,
        meta: {
            requiresAuth: true,
            permission: "DAILYBOX_MENU"
        }
    },

    {
        name: 'CashRegisterCrudPage',
        path: '/crud/cashregister',
        component: CashRegisterCrudPage,
        meta: {
            requiresAuth: true,
            permission: "CASHREGISTER_MENU"
        }
    },

    {
        name: 'PromoCrudPage',
        path: '/crud/promo',
        component: PromoCrudPage,
        meta: {
            requiresAuth: true,
            permission: "PROMO_MENU"
        }
    },

    {
        name: 'CouponCrudPage',
        path: '/crud/coupon',
        component: CouponCrudPage,
        meta: {
            requiresAuth: true,
            permission: "COUPON_MENU"
        }
    }
]

export default routes;
